(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.promotionHeroSlider = {
        attach: function (context) {
            const slider = once('promotion-hero-slider', '.promotion-banner__slider .swiper', context)[0];
            if (!slider) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const options = {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                centeredSlides: false,
                effect: 'slide',
                speed: 1000,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
            };

            try {
                new Swiper(slider, options);
                slider.classList.add('is-swiper-active');
            } catch (error) {
                console.error('Failed to initialize Swiper:', error);
            }
        }
    };

})(Drupal, once);